import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { InfiniteResult } from 'src/app/_models/body';
import { Global } from 'src/app/_services/global.service';
import { ModalService } from 'src/app/_services/modal.service';
import { VirtualMallService } from 'src/app/_services/virtual-mall.service';
import { BaseComponent } from 'src/app/ui-library/component/base.component';
import { VirtualMallTemplate } from './virtual-mall-item.constant';
import { CategoryService } from 'src/app/_services/category.service';
import { RewardService } from 'src/app/_services/reward.service';
import { forkJoin, Observable, tap } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { MmitaAssetService } from 'src/app/_services/mmitaAsset.service';

@Component({
  selector: 'app-virtual-mall',
  templateUrl: './virtual-mall.component.html',
  styleUrls: ['./virtual-mall.component.css']
})
export class VirtualMallComponent extends BaseComponent {
  headerList = []
  data: Array<any>
  formGroup: FormGroup
  assetCategories: Array<any>
  mmitaRewards: Array<any>
  aiBuddyAsset: Array<any>
  constructor(
    private virtualMallService: VirtualMallService,
    public global: Global,
    private modalService: ModalService,
    private datePipe: DatePipe,
    private categoryService: CategoryService,
    private rewardService: RewardService,
    private toastr: ToastrService,
    private mmitaAssetService: MmitaAssetService
  ) {
    super(global);

  }

  ngOnInit(): void {
    this.setColumnDefs()
  }

  setColumnDefs() {
    this.columnDefs = [
      { headerName: 'id', field: 'id' },
      { headerName: 'description', field: "description" },
      {
        headerName: 'Created At', field: 'createdAt', valueFormatter: (params) => {
          return this.datePipe.transform(params.value, 'short')
        }
      },
      {
        headerName: 'Action',
        pinned: 'right',
        minWidth: 120,
        cellRenderer: params => {
          return ` <i class="fas fa-fw fa-bars" id="moreDetail" style="margin-right:3px; cursor: pointer;"></i>
                    <i class="fas fa-fw fa-edit text-primary" id="edit" style="margin-right:3px; cursor: pointer;"></i>
                    <i class="fas fa-fw fa-trash grid-btn-icon text-danger" id="delete" style="margin-right:3px; cursor: pointer;"></i>`;

        },
        onCellClicked: params => {
          switch (params.event.target.id) {
            case 'moreDetail':
              this.modalService.showDetail(params.data, 'Detail')
              break;
            case 'edit':
              this.showItem(params?.data)
              break;
            case 'delete':
              this.modalService.createNzDeleteModal(() => this.delete.call(this, params?.data?.id))
              break;
          }
        },
      },
    ];

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
    this.getAll();
  }

  getAll() {
    this.virtualMallService.getAll().subscribe((res: InfiniteResult) => {
      this.data = res.data
    })
  }


  genFG(orgData) {
    this.formGroup = new FormGroup({
      description: new FormControl(orgData?.description),
      settingJsonUrl: new FormControl(orgData?.settingJsonUrl, Validators.required),
      productJsonUrl: new FormControl(orgData?.productJsonUrl, Validators.required),
      assetCategoryId: new FormControl(orgData?.assetCategoryId, Validators.required),
      mmitaRewardIds: new FormControl(orgData?.mmitaRewardIds || []),
      aiBuddyAssetId: new FormControl(orgData?.aiBuddyAssetId, Validators.required),
    });
  }

  // 在组件类中
  showItem(data?) {
    this.getSource().subscribe({
      next: () => {
        this.genFG(data);
        const dialogTemplate = VirtualMallTemplate(this.assetCategories, this.mmitaRewards, this.aiBuddyAsset);
        this.modalService.createNzModal(() => this.onSubmit.call(this, data?.id), this.formGroup, dialogTemplate);
      },
      error: (error) => {
        console.error('Failed to load source data:', error);
      }
    });
  }

  getSource() {
    return forkJoin({
      assetCategories: this.categoryService.getAssetCategory(),
      mmitaRewards: this.rewardService.getAll(),
      aiBuddyAsset: this.mmitaAssetService.getAll({ BusinessTypes: 'AiBuddy', PageSize: -1 })
    }).pipe(
      tap(({ assetCategories, mmitaRewards, aiBuddyAsset }) => {
        this.assetCategories = assetCategories?.data?.map(item => {
          return { ...item, name: item.multilingualNames?.['en-US'] }
        }) || [];

        this.mmitaRewards = mmitaRewards?.data || [];
        this.aiBuddyAsset = aiBuddyAsset?.data || []
      })
    );
  }

  onSubmit(id?: string) {
    return new Observable(subscriber => {

      const saveSuccess = () => {
        this.getAll()
        this.toastr.success('Data Saved Successfully...!', 'Success');
        subscriber.next();
        subscriber.complete();
      };

      const newUploadedUrl = this.formGroup.get('settingJsonUrl').value?.[0]?.origin?.url
      newUploadedUrl && this.formGroup.patchValue({ settingJsonUrl: newUploadedUrl })

      const productJsonUrl = this.formGroup.get('productJsonUrl').value?.[0]?.origin?.url
      productJsonUrl && this.formGroup.patchValue({ productJsonUrl: productJsonUrl })

      const request = id
        ? this.virtualMallService.update(id, this.formGroup.value)
        : this.virtualMallService.create(this.formGroup.value);

      request.subscribe({
        next: () => saveSuccess(),
        error: (error) => subscriber.error(error)
      });
    });
  }

  delete(id) {
    this.virtualMallService.delete(id).subscribe(res => {
      this.getAll();
      this.toastr.success('Data Delete Successfully...!', 'Success');
    })
  }
}